import { TextField, Stack, MenuItem } from '@mui/material';
import { FormikProps } from 'formik';

interface VehicleDetailsStepProps {
  formik: FormikProps<any>;
  makes: string[];
  models: string[];
  trims: string[];
  yearOptions: number[];
  mileageOptions: number[];
}

const VehicleDetailsStep = ({
  formik,
  makes,
  models,
  trims,
  yearOptions,
  mileageOptions,
}: VehicleDetailsStepProps) => {
  const fieldProps = (name: string) => ({
    name,
    value: formik.values[name],
    onChange: formik.handleChange,
    onBlur: formik.handleBlur,
    error: Boolean(formik.touched[name] && formik.errors[name]),
    helperText: formik.touched[name]
      ? formik.errors[name]?.toString()
      : undefined,
  });

  return (
    <Stack spacing={3}>
      <TextField fullWidth select label="Condition" {...fieldProps('car_type')}>
        <MenuItem value="new">New</MenuItem>
        <MenuItem value="used">Used</MenuItem>
      </TextField>
      <TextField fullWidth select label="Year" {...fieldProps('year')}>
        {yearOptions.map((year) => (
          <MenuItem key={year} value={year}>
            {year}
          </MenuItem>
        ))}
      </TextField>
      <TextField fullWidth select label="Make" {...fieldProps('make')}>
        {makes.map((makeOption) => (
          <MenuItem key={makeOption} value={makeOption}>
            {makeOption}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        fullWidth
        select
        label="Model"
        disabled={!formik.values.make}
        {...fieldProps('model')}
      >
        {models.map((modelOption) => (
          <MenuItem key={modelOption} value={modelOption}>
            {modelOption}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        fullWidth
        select
        label="Trim (optional)"
        disabled={!formik.values.model}
        {...fieldProps('trim')}
        helperText={
          formik.values.model && trims.length === 0
            ? 'Trim list unavailable right now — searching all trims'
            : fieldProps('trim').helperText
        }
      >
        <MenuItem value="">Any trim</MenuItem>
        {trims.map((trimOption) => (
          <MenuItem key={trimOption} value={trimOption}>
            {trimOption}
          </MenuItem>
        ))}
      </TextField>
      {formik.values.car_type === 'used' && (
        <Stack direction="row" spacing={2}>
          <TextField
            fullWidth
            select
            label="Min mileage"
            {...fieldProps('minMileage')}
          >
            {mileageOptions.map((miles) => (
              <MenuItem key={miles} value={miles}>
                {miles.toLocaleString()} miles
              </MenuItem>
            ))}
          </TextField>
          <TextField
            fullWidth
            select
            label="Max mileage"
            {...fieldProps('maxMileage')}
          >
            {mileageOptions.map((miles) => (
              <MenuItem key={miles} value={miles}>
                {miles.toLocaleString()} miles
              </MenuItem>
            ))}
          </TextField>
        </Stack>
      )}
    </Stack>
  );
};

export default VehicleDetailsStep;
